import {TdoDropdownModel} from '../../../../tdo-controls/common/tdo-basic-dropdown/models/tdo-dropdown.model';

export class TdoOrganizerStaticDataset {
  imageSizes: TdoDropdownModel[] = [];
  organizerViews: TdoDropdownModel[] = [];
  organizerSortMethods: TdoDropdownModel[] = [];

  constructor() {
    const imageSize_64 = new TdoDropdownModel('Size: 64x64', 64);
    const imageSize_80 = new TdoDropdownModel('Size: 80x80', 80);
    const imageSize_96 = new TdoDropdownModel('Size: 96x96', 96);
    const imageSize_128 = new TdoDropdownModel('Size: 128x128', 128);
    const imageSize_150 = new TdoDropdownModel('Size: 150x150', 150);
    const imageSize_175 = new TdoDropdownModel('Size: 175x175', 175);
    const imageSize_200 = new TdoDropdownModel('Size: 200x200', 200);
    const imageSize_250 = new TdoDropdownModel('Size: 250x250', 250);
    const imageSize_400 = new TdoDropdownModel('Size: 400x400', 400);

    this.imageSizes.push(imageSize_64);
    this.imageSizes.push(imageSize_80);
    this.imageSizes.push(imageSize_96);
    this.imageSizes.push(imageSize_128);
    this.imageSizes.push(imageSize_150);
    this.imageSizes.push(imageSize_175);
    this.imageSizes.push(imageSize_200);
    this.imageSizes.push(imageSize_250);
    this.imageSizes.push(imageSize_400);

    const viewDetail = new TdoDropdownModel('View: Detail', 'detail');
    const galleryDetail = new TdoDropdownModel('View: Gallery', 'gallery');
    const paneDetail = new TdoDropdownModel('View: Pane', 'pane');
    const thumbnailDetail = new TdoDropdownModel('View: Thumbnail', 'thumbnail');
    const thumbnailZoomDetail = new TdoDropdownModel('View: Thumbnail Zoom', 'thumbnail_zoom');
    this.organizerViews.push(viewDetail);
    this.organizerViews.push(galleryDetail);
    this.organizerViews.push(paneDetail);
    this.organizerViews.push(thumbnailDetail);
    this.organizerViews.push(thumbnailZoomDetail);

    const userDefined = new TdoDropdownModel('Sort: User Defined', 'user_defined');
    const sortDateCreated = new TdoDropdownModel('Sort: Date Created', 'date_created');
    const sortDateModified = new TdoDropdownModel('Sort: Date Modified', 'date_modified');
    this.organizerSortMethods.push(userDefined);
    this.organizerSortMethods.push(sortDateCreated);
    this.organizerSortMethods.push(sortDateModified);
  }
}
